import React from 'react';
import { LicenseCheck } from '@atlassian/jira-spa-apps-common/src/interceptors/license/index.tsx';
import { RouterSubscriber, Redirect } from '@atlassian/react-resource-router';

const QueuesIssueViewRedirect = () => (
	<LicenseCheck type="servicedesk">
		{({ result }) => (
			<RouterSubscriber>
				{({ match }) =>
					// eslint-disable-next-line no-nested-ternary
					match && match.params && match.params.issueKey ? (
						result ? (
							<Redirect
								to={`/jira/servicedesk/projects/${String(
									match.params.projectKey,
								)}/queues/issue/${String(match.params.issueKey)}`}
							/>
						) : (
							<Redirect to={`/browse/${String(match.params.issueKey)}`} />
						)
					) : null
				}
			</RouterSubscriber>
		)}
	</LicenseCheck>
);

export default QueuesIssueViewRedirect;
